(function () {
  function readSymptoms(section) {
    const script = section.querySelector('[id^="QuizRecommendationsSymptoms-"]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return [];
    }
  }

  function computeRankedSymptoms(answers, symptoms) {
    const symptomMap = Object.fromEntries(symptoms.map((symptom) => [symptom.handle, symptom]));
    const bySymptom = {};

    answers.forEach((answer) => {
      if (!answer.symptomHandle) return;
      const existing = bySymptom[answer.symptomHandle];
      if (!existing || Number(answer.score) > Number(existing.score)) {
        bySymptom[answer.symptomHandle] = answer;
      }
    });

    return Object.values(bySymptom).sort((a, b) => {
      if (Number(b.score) !== Number(a.score)) return Number(b.score) - Number(a.score);
      const priorityA = Number(symptomMap[a.symptomHandle]?.resultsPriority ?? 999);
      const priorityB = Number(symptomMap[b.symptomHandle]?.resultsPriority ?? 999);
      return priorityA - priorityB;
    });
  }

  // Keep recommendation answers; mark results viewed so homepage won't keep an
  // open modal if the browser restores a cached snapshot.
  function markQuizResultsViewed(sessionKey, session) {
    if (!session) return session;

    const nextSession = {
      ...session,
      resultsViewed: true,
    };

    try {
      sessionStorage.setItem(sessionKey, JSON.stringify(nextSession));
    } catch (error) {
      // Ignore storage failures; recommendations can still render from memory.
    }

    return nextSession;
  }

  function initQuizRecommendations() {
    document.querySelectorAll('[data-quiz-recommendations]').forEach((section) => {
      if (section.dataset.recInitialized === 'true') return;
      section.dataset.recInitialized = 'true';

      const sessionKey = section.dataset.sessionKey || 'menolabs_quiz_session';
      const emailRequired = section.dataset.emailRequired === 'true';
      const fallbackMode = section.dataset.fallbackMode || 'hide_all';

      const lockedEl = section.querySelector('[data-quiz-rec-locked]');
      const emptyEl = section.querySelector('[data-quiz-rec-empty]');
      const sectionsContainer = section.querySelector('[data-quiz-rec-sections]');
      const groups = Array.from(section.querySelectorAll('[data-quiz-rec-group]'));
      const symptoms = readSymptoms(section);

      let session = null;
      try {
        const raw = sessionStorage.getItem(sessionKey);
        session = raw ? JSON.parse(raw) : null;
      } catch (error) {
        session = null;
      }

      if (session) {
        session = markQuizResultsViewed(sessionKey, session);
      }

      if (!session?.answers?.length || (emailRequired && !session.emailSubmitted)) {
        if (lockedEl) lockedEl.hidden = false;
        if (emptyEl) emptyEl.hidden = true;
        groups.forEach((group) => {
          group.hidden = true;
        });
        return;
      }

      if (lockedEl) lockedEl.hidden = true;

      const ranked = computeRankedSymptoms(session.answers, symptoms).map((answer) => ({
        symptomHandle: answer.symptomHandle,
      }));

      if (!ranked.length) {
        if (fallbackMode === 'show_message' && emptyEl) {
          emptyEl.hidden = false;
        }
        groups.forEach((group) => {
          group.hidden = true;
        });
        return;
      }

      if (emptyEl) emptyEl.hidden = true;

      const groupMap = Object.fromEntries(groups.map((group) => [group.dataset.symptomHandle, group]));

      ranked.forEach((item) => {
        const group = groupMap[item.symptomHandle];
        if (!group) return;
        group.hidden = false;
        sectionsContainer.appendChild(group);
      });

      groups.forEach((group) => {
        if (!ranked.some((item) => item.symptomHandle === group.dataset.symptomHandle)) {
          group.hidden = true;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuizRecommendations);
  } else {
    initQuizRecommendations();
  }

  document.addEventListener('shopify:section:load', initQuizRecommendations);
})();
